import { useEffect, useState } from "react";
import { Button } from "../components/ui/button";

const KEY = "lime_cookie_consent_v1";

function gtag() { /* eslint-disable-next-line prefer-rest-params */ window.dataLayer.push(arguments); }

function applyConsent(state) {
  // Google Consent Mode v2
  window.dataLayer = window.dataLayer || [];
  gtag("consent", "update", {
    ad_storage: state.marketing ? "granted" : "denied",
    ad_user_data: state.marketing ? "granted" : "denied",
    ad_personalization: state.marketing ? "granted" : "denied",
    analytics_storage: state.analytics ? "granted" : "denied",
    functionality_storage: "granted",
    security_storage: "granted",
  });
}

// Default-denied baseline on load
(function setDefaultConsent() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  function _gtag() { window.dataLayer.push(arguments); }
  _gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "granted",
    security_storage: "granted",
    wait_for_update: 500,
  });
})();

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) setVisible(true);
    else {
      try { applyConsent(JSON.parse(stored)); } catch { /* noop */ }
    }
  }, []);

  const acceptAll = () => {
    const state = { analytics: true, marketing: true, ts: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(state));
    applyConsent(state);
    setVisible(false);
  };
  const rejectAll = () => {
    const state = { analytics: false, marketing: false, ts: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(state));
    applyConsent(state);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-8 md:right-auto md:max-w-md z-50 bg-white border border-black/10 shadow-xl rounded-2xl p-5"
         data-testid="cookie-banner" role="dialog" aria-live="polite">
      <h3 className="text-base font-medium text-[#111827]">Cookies & privacy</h3>
      <p className="text-sm text-[#4B5563] mt-2 leading-relaxed">
        We use essential cookies and, with your consent, analytics &amp; marketing cookies to improve our website.
        You can change your choice at any time.
      </p>
      <div className="flex gap-2 mt-4">
        <Button variant="outline" onClick={rejectAll} data-testid="cookie-reject-btn"
                className="border-black/15 hover:bg-black/5">Reject non-essential</Button>
        <Button onClick={acceptAll} data-testid="cookie-accept-btn"
                className="bg-[#37B160] text-white hover:bg-[#2D9450]">Accept all</Button>
      </div>
    </div>
  );
}
